import { DisplayPrice, ItemState } from "../api/generated";

export class ItemStates {
    private itemStates: { [key: string]: ItemState } = {};

    constructor(states: ItemState[]) {
        states.forEach(state => {
            this.itemStates[state.id] = state;
        });
    }

    isSelected(id: string): boolean {
        return this.itemStates[id]?.selected || false;
    }

    getPrice(id: string): DisplayPrice | null {
        return this.itemStates[id]?.price || null;
    }
}
